import { Link } from "react-router-dom";

const IOS_TESTFLIGHT_URL = "https://testflight.apple.com/join/u4KVQCMt";
const ANDROID_BETA_URL = "https://play.google.com/apps/testing/org.zionclassical.app";
const ANDROID_STORE_URL = "https://play.google.com/store/apps/details?id=org.zionclassical.app";
const FEEDBACK_FORM_URL = "https://forms.gle/trG2cJpBRRuAPySCA";

export function BetaLandingPage() {
  return (
    <div className="beta-page">
      <section className="beta-hero card">
        <div className="section-eyebrow">ZCA App</div>
        <h1>Install the Zion Classical Academy app</h1>
        <p className="muted beta-lead">
          Use this page to install the app on iPhone or Android and complete account setup.
        </p>
      </section>

      <section className="beta-grid">
        <div className="card section-card beta-step">
          <div className="section-eyebrow">Step 1</div>
          <h2>Watch for your account setup email</h2>
          <p className="muted">
            Before signing in, look for an email titled <strong>“Zion Classical Academy Account Setup”</strong>.
            Use that email to set your password and finish activating your account.
          </p>
          <p className="muted">
            If you do not see it, check your spam or junk folder first.
          </p>
        </div>

        <div className="card section-card beta-step">
          <div className="section-eyebrow">Step 2</div>
          <h2>Install the app</h2>
          <div className="beta-platforms">
            <div className="beta-platform card">
              <h3>iPhone / iPad</h3>
              <p className="muted">
                Install TestFlight, then open the Zion Classical Academy app invite.
              </p>
              <div className="beta-actions">
                <a className="btn" href={IOS_TESTFLIGHT_URL} target="_blank" rel="noreferrer">
                  Open TestFlight Invite
                </a>
              </div>
            </div>

            <div className="beta-platform card">
              <h3>Android</h3>
              <p className="muted">
                Open the Google Play listing, then install the Zion Classical Academy app.
              </p>
              <div className="beta-actions beta-actions-stack">
                <a className="btn" href={ANDROID_BETA_URL} target="_blank" rel="noreferrer">
                  Open Android Install Link
                </a>
                <a className="btn secondary" href={ANDROID_STORE_URL} target="_blank" rel="noreferrer">
                  Open Play Store Listing
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="card section-card beta-step">
          <div className="section-eyebrow">Step 3</div>
          <h2>Sign in</h2>
          <ul className="beta-list muted">
            <li>Sign in with the email address your ZCA account was created for.</li>
            <li>Open <strong>Messages</strong> and verify conversations load correctly.</li>
            <li>Review announcements, calendar, and messaging access.</li>
          </ul>
        </div>

        <div className="card section-card beta-step">
          <div className="section-eyebrow">Step 4</div>
          <h2>Get support</h2>
          <p className="muted">
            Use the support form to report app issues or request help with account access.
          </p>
          <div className="beta-actions">
            <a className="btn" href={FEEDBACK_FORM_URL} target="_blank" rel="noreferrer">
              Open Support Form
            </a>
          </div>
        </div>
      </section>

      <section className="card section-card beta-footer-card">
        <div className="section-eyebrow">Need help?</div>
        <p className="muted">
          If your account setup email has not arrived or you are unable to sign in after setting your
          password, contact the school office.
        </p>
        <p className="muted" style={{ marginBottom: 0 }}>
          Admin staff can return to the <Link to="/login">Admin Web login</Link>.
        </p>
      </section>
    </div>
  );
}
